module.exports = __webpack_public_path__ + "img/bg.2353d962.jpg";